import { createAction, props } from '@ngrx/store';

const AUTH_KEY = '[Auth]';

export interface ICredentials {
  email: string;
  password: string;
}

export const AuthLoading = createAction(
  `${AUTH_KEY} loading`,
  props<{ loading: boolean }>()
);

export const SignUp = createAction(
  `${AUTH_KEY} sign up`,
  props<{ creds: ICredentials }>()
);

export const SignUpSuccess = createAction(
  `${AUTH_KEY} sign up success`,
  props<{ payload: { res: any, email: string }}>()
);

export const SignUpFailure = createAction(
  `${AUTH_KEY} sign up failure`,
  props<any>()
);

export const Login = createAction(
  `${AUTH_KEY} login`,
  props<{ creds: ICredentials }>()
);

export const LoginSuccess = createAction(
  `${AUTH_KEY} login success`,
  props<any>()
);

export const LoginFailure = createAction(
  `${AUTH_KEY} login failure`,
  props<any>()
);

export const Verify = createAction(
  `${AUTH_KEY} verify`,
  props<{ code: string }>()
);

export const VerifySuccess = createAction(
  `${AUTH_KEY} verify success`,
  props<any>()
);

export const VerifyFailure = createAction(
  `${AUTH_KEY} verify failure`,
  props<any>()
);
